import { Card, Flex, Icons, Tag, theme, Typography } from '@contiple/antd-ds';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { HOME_URL } from '@/constants';
import type { NewsItem } from '@/types/dashboard';

const { Text } = Typography;

interface NewsListProps {
  data: NewsItem[];
}

export default function NewsList({ data }: NewsListProps) {
  const { t, i18n } = useTranslation();
  const { token } = theme.useToken();

  const handleOpenNotice = () => {
    window.open(
      `${HOME_URL}/${i18n.language}/resource/notice`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <Card
      title={t('dashboard.news')}
      extra={
        <Icons.ChevronRight
          size={16}
          style={{ cursor: 'pointer' }}
          onClick={handleOpenNotice}
        />
      }
      style={{
        flex: 2,
        minWidth: 0,
        height: 266,
        borderRadius: 12,
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
      }}
      styles={{
        header: {
          padding: '20px 20px 16px',
          minHeight: 0,
          borderBottom: 'none',
        },
        body: {
          flex: 1,
          overflow: 'auto',
          padding: '12px 20px 20px',
        },
      }}>
      <Flex vertical gap={16}>
        {data.map((item) => (
          <Flex key={item.id} align="center" gap={8}>
            <Tag
              style={{
                backgroundColor: token.colorBorder,
                color: token.colorTextSecondary,
                border: 'none',
                fontSize: 12,
                lineHeight: '14px',
                padding: '0 6px',
                height: 20,
                borderRadius: 3,
                margin: 0,
                display: 'inline-flex',
                alignItems: 'center',
                flexShrink: 0,
              }}>
              {item.category}
            </Tag>
            <Text ellipsis style={{ flex: 1, minWidth: 0 }}>
              {item.link ? (
                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: 'inherit', cursor: 'pointer' }}>
                  {item.title}
                </a>
              ) : (
                item.title
              )}
            </Text>
            <Text
              type="secondary"
              className="tabular-nums"
              style={{
                flexShrink: 0,
                fontSize: 12,
                width: 54,
                textAlign: 'right',
              }}>
              {dayjs(item.createdDate).format('YY.MM.DD')}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Card>
  );
}
